export default __webpack_public_path__ + "static/media/jamf-icon.3b93bc25.svg";